export const createFavoriteId = (
  compositionId: string,
  sellableId: string,
  appearanceId: string
) => {
  return `${compositionId}-${sellableId}-${appearanceId}`;
};
